import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { logOutOutline } from 'ionicons/icons';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebaseConfig';

const LogoutButton: React.FC = () => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <IonButton onClick={handleLogout}>
      <IonIcon icon={logOutOutline} slot="start" />
      Logout
    </IonButton>
  );
};

export default LogoutButton;
